module.exports = __webpack_public_path__ + "static/media/search-light.025f5ca1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search-light.svg
// module id = 3100
// module chunks = 0